import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useFeatureFlags } from 'src/features/user';
import { ConciergeErrorResponse } from 'src/api/concierge';

import { RebookActiveInfo } from '../api/types';
import { RebookingEndpoints } from '../api/constants';
import { getRebookInfo } from '../api/requests';

export const useGetRebookingInfo = () => {
    const { rebook } = useFeatureFlags();

    return useQuery<RebookActiveInfo, AxiosError<ConciergeErrorResponse>>({
        queryKey: [RebookingEndpoints.GetRebookActive],
        enabled: rebook,
        queryFn: async () => getRebookInfo(),
    });
};
